import React, { memo, useState, useEffect, useCallback } from 'react'
import DSSelect from '@/components/DataSourceSelect'

const Index = (props: any) => {
    const [state, setState] = useState('')

    useEffect(() => {

    })

    return (<div><DSSelect param={{dictIds: ["1888875593567633409"]}} /></div>)
}

export default Index